import React from 'react';
import { JdsTag } from '../../../components/jds/JdsTag';
import { formatCurrency, formatCycle } from '../utils';

const META_ROWS = [
  {
    key: 'displayClient',
    label: 'Visível ao cliente',
    format: (plan) => (plan.displayClient ? 'Sim' : 'Não'),
  },
];

export function PlanCard({ plan, selected, onToggleSelected }) {
  return (
    <div className="jds-card h-100 d-flex flex-column">
      <div className="d-flex align-items-start justify-content-between mb-4">
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: 'var(--space-8)' }}
        >
          <h2 className="jds-title-sm">{plan.name}</h2>
          <JdsTag color="brand" label={formatCycle(plan.cycleDays)} />
        </div>
        <JdsTag
          dot
          label={plan.active ? 'Ativo' : 'Inativo'}
          color={plan.active ? 'success' : 'error'}
        />
      </div>

      <label
        className="d-flex align-items-center mb-4 text-muted"
        style={{ gap: 'var(--space-8)', minHeight: 24, cursor: 'pointer' }}
      >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelected(plan.id)}
        />
        Incluir no comparativo
      </label>

      <div className="mb-6">
        <span className="jds-title-lg">{formatCurrency(plan.amount)}</span>
        <span className="text-muted">
          {' '}
          / {formatCycle(plan.cycleDays).toLowerCase()}
        </span>
      </div>

      <dl className="mb-0 mt-auto">
        {META_ROWS.map(({ key, label, format }) => (
          <div
            key={key}
            className="d-flex justify-content-between"
            style={{
              padding: 'var(--space-8) 0',
              borderTop:
                'var(--stroke-small) solid var(--border-neutral-subtle)',
            }}
          >
            <dt className="text-muted mb-0" style={{ fontWeight: 'inherit' }}>
              {label}
            </dt>
            <dd className="mb-0 text-right">{format(plan)}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
